import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
import { SpecialBook } from '../adhoc/blog/all-wrapped.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Near the end of 2020, we had a new family member...`}</p>
    <h1>{`Welcome!`}</h1>
    <p>{`Welcome to this new world and welcome to our family! You and your elder brother are my special little ones who one day will help make our world better. 🥰 `}</p>
    <p>{`Love, ❤️`}</p>
    <p>{`from Mom and Dad.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6c3e32751d4d92097e7115edf7e1c280/a4262/alex.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "108.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAAAsSAAALEgHS3X78AAAFbElEQVQ4yy2U2VMb6RXF+39KqpKHqUrFScYLZWJsMGDMIoSwNoTQvgstrX1HEkISQojNLAIEhjHY4+RlPJlkpjKpmZf8Nb9cq/Jwq7q6vz7fueece5Xd3iH5fB6L20tvt8P9oE/av07at06zVGGrWqUplQmsEzTbCFnsWGZmWZt/iXd5EvP0CKrDQNSmx7owjpItVkkkU+iMZqry46dvBhQiKkl3iLKaplnZYKtUJukNEjQJ4IoN69wCKzMvCBpfY3j5kNiajsiaHtP0U5TNrTaqqrIsh4PBGJ9uL9nM5Ei6giQ9QeJOnxx2EbY4hgyDZiv2BS2GyWf430xhnnwsF82hOk3y7okwzJVxOT1oly0s6W18uD6nU6lIGz5SAqjavUSt/wc0rREwreLSLqOf+OuwZcv0E9zal2R9q8JwBGXFo/Jaa2VmVs/UKz3nh3scbNWHgElXgLgARgQwZLENwYJGiwAZBXAMp+YFlqnHWGeeUgw7RNcxlEfzYUYXYjwdNzL6XEuzVqff2ybu8JJw+onZPKyvOgmurOEzmHEv6fFIGScnWJsbw/pqBOvr0SGgQy5QArEqla0bqhttus0Gg7f7XOzvEHO4h+xidgG0OgiYV+Wdi7IYWFITuHQaQuYFMWke5+K4tGzBszyFct/v8uFqwPXpsTBrcrLbYq9ZJR0IiLN+4hKn7HqUo94+93cf+fjt3zg5PmW/06VZLtGu14X5HLHVBTy6SZSoy4Hq9ZAOh4lWG/gbO6jRpBjiJyG1WaxwcT7g/fuP3N194t3NPfVylXx0nYoaolXO0CzE2Yi5xZwJFNUZEK18ZPxhvJVtVhsHqMkSeY2WvajKYHDF+ekJl/1Tbq8HvBucc3bU4/K4R7eeY6sQoxC2sbuRIiTxUb4AlaIJ8rka+UaPzeoGnWqZTj7FfqPKQbdFq16iXslSkyrlE2TUAGdvu2yXE0JmmbhtiVY2RMLxBmUjaKEesVEKW6nlomykgtRKacrFLIWsSjEjDFJhcgk/maiLbMSJ6l+hnPCyU83iXXqObeYRKYeOfMCKUgtb8L/6I1HTlIhvJxO0inZGonaduLokk6KT50WZloVhZf1GyajEKxeUduOSw4esvPgDft0LanEvSkdoFyN2icgi6yszosMUSadW2tBIBjUS7mXSXsOwonYtfuOr4bdCwMyO6JZ2G3DMShanv6aR9KO0C9HhYd+bCUn+MwnuGPqpRxhkpJzacVkCT9A+f4Bm7E9oJx6zMD5Cxq1nU3UxOGxzudcgbJhGP/qVMHSj1FM+McUhLpupJX2EnSuEfS4axaRo5qdRznHcazE42ePjTZ+/311ze7rHSavA4KDFZW+TmGWe2T//hmJgFaUshhy2K7RrReJhP4YlDen4Otr5GVbeLBIPegi6ZW157SxrpsklI9wed+jkApx3q1wftiiFVtE9+4q8mKWkvUaZjqbsvRzpSIBiMkY+KW7nk7SqRZobBZmGMn3Jnm7xNZq5Ke76ksFCiH6nLIBtdgphXJqnlCQxStpnor/fob+3LXPc4/rskNvLE94Pzrg5f8s38nx3dcbdu3Pur085apWHrR7VEpy1C1wdNEl7DJhmRglZl1B+/Pcv/Pzrf/nHD//i4viAo26TTCxEIRHh/GhXJmKPq5OD4UXvL96yV88OzTgUwMN6ii3J7vTXv2P24W9xzj5CSQTsdFubfPfPn/jhp/8IYIvdRoWD7U36h90h6IUwH5zsc9M/4qxb41Km5FTYJSRqjXQA//xfcL/8PaH5Byh+WUFRu36o0+cff+b7z5/5cHvFmYCdiAxnBztD4C/1hWVY2jLLQo3IdolIbnfLcYq2cRJLD8iYRvgf0m1g+OdgbxUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Your Are Special",
            "title": "Your Are Special",
            "src": "/static/6c3e32751d4d92097e7115edf7e1c280/0a47e/alex.png",
            "srcSet": ["/static/6c3e32751d4d92097e7115edf7e1c280/8a4e8/alex.png 150w", "/static/6c3e32751d4d92097e7115edf7e1c280/5a46d/alex.png 300w", "/static/6c3e32751d4d92097e7115edf7e1c280/0a47e/alex.png 600w", "/static/6c3e32751d4d92097e7115edf7e1c280/a4262/alex.png 814w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Your Are Special`}</figcaption>{`
  `}</figure>
    <p>{`Here's your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`You are S.P.E.C.I.A.L`}</code>{` ebook!`}</p>
    <SpecialBook mdxType="SpecialBook" />
    <p>{`made by Dad, William, powered by `}<a parentName="p" {...{
        "href": "https://nodlik.github.io/react-pageflip/"
      }}>{`STFlip`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.flaticon.com/"
      }}>{`Flaticon`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      